<template>
  <div style="margin-top:-10px !important">
    <RecordNotFound v-if="status_code == 404" :message="status_message"></RecordNotFound>
    <template v-else>
      <b-row
        class="hidden-sm-down d-print-none px-pad border-bottom justify-content-center"
        style="height: 42px"
      >
        <!-- <b-col m5="1"></b-col> -->
        <b-col cols="4" md="4" xl="4" lg="4" sm="4" xs="4" class="text-left px-0">
          <!--  invoice header details -->

          <!--  invoice no and status name -->
          <h2 class="custom-page-title mb-2 mt-1">
            {{ list.quotation_header_detail.quot_no }} -
            <small>{{ list.quotation_header_detail.quot_status_name }}</small>
          </h2>
        </b-col>
        <b-col cols="8" md="8" xl="8" lg="8" sm="8" xs="8" class="text-right px-0">
          <template v-if="list.quotation_header_detail.quot_status != 8">
            <b-button
              variant="primary"
              size="sm"
              @click="convertmodule = 'invoice'"
              v-b-modal.converttoinvoice
              class="mr-2"
              v-if="
                (!general_settings_details.preferences.bill_of_supply ||
                  list.is_non_taxable != '1') &&
                RoutePermission(false, '', 'invoice', 'invoice', 'create')
                  ? true
                  : false
              "
              >Convert to Invoice</b-button
            >
            <b-button
              @click="convertmodule = 'Bill of supply'"
              variant="primary"
              size="sm"
              class="mr-2"
              v-if="
                general_settings_details.preferences.bill_of_supply &&
                list.is_non_taxable == '1' &&
                RoutePermission(false, '', 'invoice', 'invoice', 'create')
                  ? true
                  : false
              "
              v-b-modal.converttoinvoice
              >Convert to Bill of Supply</b-button
            >
          </template>
          <!-- <b-button
            variant="success"
            size="sm"
            @click="convertmodule = 'sales order'"
            
            v-show="list.quotation_header_detail.quot_status == 2 &&  RoutePermission(false,'','invoice','salesorder','create') ? true  : false"
            v-b-modal.converttoinvoice
        >Convert To Sales Order</b-button>-->
          <b-button
            variant="success"
            size="sm"
            title="Approve"
            class="mr-2"
            v-if="
              list.quotation_header_detail.quot_status == 1 &&
                RoutePermission(false, '', 'invoice', 'quotation', 'approve')
            "
            @click="
              handlingapprovingmodal({
                content: 'Are you sure you want to approve this Quotation ?',
                title: 'Approve Quotation-' + list.quotation_header_detail.quot_no,
                module: 'sales/approvequotation',
                data: JSON.stringify({
                  id: $route.params.id,
                }),
                RoutePlace: '',
                isRoute: 'false',
                type: 'approve',
              })
            "
            >Approve</b-button
          >
          <b-button
            variant="primary"
            size="sm"
            class="mr-2"
            v-if="RoutePermission(false, '', 'invoice', 'quotation', 'create')"
            :to="{ name: 'SalesCreate', query: { page_from: 'view', old_id: $route.params.id } }"
          >
            New Quotation
          </b-button>

          <b-button-group variant="light">
            <b-button
              v-if="
                ((RoutePermission(false, '', 'invoice', 'quotation', 'update') &&
                  list.quotation_header_detail.quot_status < 2) ||
                  (RoutePermission(false, '', 'invoice', 'quotation', 'approvedaccess') &&
                    list.quotation_header_detail.quot_status >= 2)) &&
                  list.quotation_header_detail.quot_status != '5'
              "
              size="sm"
              :to="{
                name: 'SalesUpdate',
                params: { id: $route.params.id },
                query: { page_from: 'view' },
              }"
              variant="light"
            >
              <i class="la la-edit la-lg"></i>
            </b-button>

            <b-button variant="light" size="sm" title=" print" @click="handlePrint()">
              <i class="la la-print la-lg"></i>
            </b-button>
            <b-dropdown
              right
              text="More"
              variant="light"
              size="sm"
              v-if="
                RoutePermission(false, '', 'invoice', 'salesorder', 'create') ||
                  RoutePermission(false, '', 'invoice', 'quotation', 'create') ||
                  (RoutePermission(false, '', 'invoice', 'quotation', 'update') &&
                    list.quotation_header_detail.quot_status < 2) ||
                  (RoutePermission(false, '', 'invoice', 'quotation', 'approvedaccess') &&
                    list.quotation_header_detail.quot_status >= 2) ||
                  RoutePermission(false, '', 'invoice', 'paymentsreceived', 'create') ||
                  RoutePermission(false, '', 'invoice', 'quotation', 'delete') ||
                  RoutePermission(false, '', 'invoice', 'quotation', 'email') ||
                  RoutePermission(false, '', 'invoice', 'settings', 'templates')
              "
            >
              <b-dropdown-item
                @click="converttoretainer()"
                v-if="
                  list.quotation_header_detail.quot_status == 7 &&
                    general_settings_details.preferences.modules.RetainerInvoice &&
                    RoutePermission(true, 'RetainerInvoiceCreate', '', '', '')
                "
              >
                <i class="la la-credit-card la-lg mr-3"></i>Create Customer Deposit
              </b-dropdown-item>
              <template
                v-if="
                  list.quotation_header_detail.quot_status != 1 &&
                    list.quotation_header_detail.quot_status != 3 &&
                    ((RoutePermission(false, '', 'invoice', 'quotation', 'update') &&
                      list.quotation_header_detail.quot_status < 2) ||
                      (RoutePermission(false, '', 'invoice', 'quotation', 'approvedaccess') &&
                        list.quotation_header_detail.quot_status >= 2))
                "
              >
                <b-dropdown-item
                  v-if="
                    list.quotation_header_detail.quot_status != 7 &&
                      RoutePermission(false, '', '', 'quotation', 'update')
                  "
                  @click="
                    handlingapprovingmodal({
                      content: 'Are you sure you want to accept this Quotation ?',
                      title: 'Accept Quotation - ' + list.quotation_header_detail.quot_no,
                      module: 'sales/accpetdeclinestatus',
                      data: JSON.stringify({
                        quot_hdr_id: $route.params.id,
                        quot_status: 7,
                      }),
                      RoutePlace: '',
                      isRoute: 'false',
                      type: 'accept',
                    })
                  "
                >
                  <i class="la la-check la-lg mr-3"></i>Mark as Accepted
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="
                    list.quotation_header_detail.quot_status != 8 &&
                      RoutePermission(false, '', '', 'quotation', 'update')
                  "
                  @click="
                    handlingapprovingmodal({
                      content: 'Are you sure you want to decline this Quotation ?',
                      title: 'Decline Quotation - ' + list.quotation_header_detail.quot_no,
                      module: 'sales/accpetdeclinestatus',
                      data: JSON.stringify({
                        quot_hdr_id: $route.params.id,
                        quot_status: 8,
                      }),
                      RoutePlace: '',
                      isRoute: 'false',
                      type: 'accept',
                    })
                  "
                >
                  <i class="la la-ban la-lg mr-3"></i> Mark as Declined
                </b-dropdown-item>
              </template>
              <b-dropdown-item
                :to="{
                  name: 'SalesCreate',
                  query: {
                    clone_id: list.quotation_header_detail.quot_hdr_id,
                    page_from: 'view',
                  },
                }"
                v-if="RoutePermission(false, '', 'invoice', 'quotation', 'create')"
              >
                <i class="la la-copy la-lg mr-3"></i>Clone
              </b-dropdown-item>
              <b-dropdown-item
                v-if="
                  list.quotation_header_detail.quot_status != 3 &&
                    ((RoutePermission(false, '', 'invoice', 'quotation', 'delete') &&
                      list.quotation_header_detail.quot_status < 2) ||
                      (RoutePermission(false, '', 'invoice', 'quotation', 'approvedaccess') &&
                        list.quotation_header_detail.quot_status >= 2))
                "
                @click="
                  handlingapprovingmodal({
                    content: 'Are you sure you want to delete this Quotation ?',
                    title: 'Delete Quotation - ' + list.quotation_header_detail.quot_no,
                    module: 'sales/deletequotation',
                    data: JSON.stringify({
                      id: $route.params.id,
                    }),
                    RoutePlace: 'Sales',
                    isRoute: 'true',
                    type: 'delete',
                    route_history: sales_index_history,
                  })
                "
              >
                <i class="la la-trash la-lg mr-3"></i>Delete
              </b-dropdown-item>
              <b-dropdown-item
                v-if="
                  list.quotation_header_detail.quot_status != '5' &&
                    RoutePermission(false, '', '', 'quotation', 'email')
                "
                @click="emailstatement()"
              >
                <i class="la la-envelope-o la-lg mr-3"></i>
                Mail
              </b-dropdown-item>

              <b-dropdown-item
                @click="showFullLayout"
                v-if="RoutePermission(false, '', 'invoice', 'settings', 'templates')"
              >
                <i class="la la-cog la-lg mr-3"></i>Customize Print
              </b-dropdown-item>
            </b-dropdown>

            <b-button
              variant="light"
              size="sm"
              title="close"
              :to="sales_index_history ? sales_index_history : { name: 'Sales' }"
            >
              <i class="la la-remove la-lg text-decoration-none"></i>
            </b-button>
            <!-- <a title=" print" id="print_url" size="sm" href="#" class="btn btn-light"></a> -->
          </b-button-group>
          <!-- <a title=" attach" href="#" class="btn btn-light" @click="$router.go(-1)">
            <i class="la la-remove la-lg text-decoration-none"></i>
        </a>-->
        </b-col>
      </b-row>

      <div class="view-block-tab" style="margin-left: -20px; margin-right: -20px">
        <b-tabs class="customer_view_tab no-flex-grow mb-5 mt-2 border-tab">
          <b-tab title="Quotation View">
            <StandardPrint
              class="custom-md-width"
              v-if="quot_settings_details.print.templateId == 4"
              :showprintlabel="showprintlabel"
              :printlabel="printlabel"
              :list="list"
            ></StandardPrint>
            <SpreadsheetPrint
              class="custom-md-width"
              v-else-if="quot_settings_details.print.templateId == 5"
              :showprintlabel="showprintlabel"
              :printlabel="printlabel"
              :list="list"
            ></SpreadsheetPrint>
            <RetailPrint
              class="custom-md-width"
              v-else-if="quot_settings_details.print.templateId == 6"
              :showprintlabel="showprintlabel"
              :printlabel="printlabel"
              :list="list"
            ></RetailPrint>
          </b-tab>
          <b-tab
            class="px-0 py-0"
            v-if="
              list.invoice_details.length > 0 &&
                RoutePermission(false, '', 'invoice', 'invoice', 'index')
            "
            :title="'Invoices(' + list.invoice_details.length + ')'"
          >
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th style="width: 140px; padding-left: 15px !important">
                      DATE
                    </th>
                    <th style="width: 85px">INVOICE</th>
                    <th style="width: 110px">STATUS</th>
                    <th style="width: 140px">DUE DATE</th>
                    <th class="text-right" style="min-width: 140px">AMOUNT</th>
                    <th class="text-right" style="min-width: 140px; padding-right: 15px !important">
                      BALANCE DUE
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in list.invoice_details" :key="index">
                    <td>{{ getDateFormat(item.created_date) }}</td>
                    <td style="padding-left: 15px !important">
                      <router-link
                        v-if="RoutePermission(false, '', 'invoice', 'invoice', 'index')"
                        class="event-link theme-text-color"
                        :to="{
                          name: 'InvoiceView',
                          params: { id: item.inv_hdr_id },
                          query: {
                            page_from: 'quot_view',
                            id: $route.params.id,
                            view_no: list.quotation_header_detail.quot_no,
                          },
                        }"
                        >{{ item.inv_no }}</router-link
                      >
                      <template v-else>{{ item.inv_no }}</template>
                    </td>
                    <td>{{ item.inv_status_name }}</td>
                    <td>{{ getDateFormat(item.due_date) }}</td>
                    <td class="text-right">
                      {{
                        getDetails(
                          $AppDetails.currency_details,
                          item.cus_currency,
                          "currency_symbol"
                        ) +
                          " " +
                          parseFloat(item.export_grand_total).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                      }}
                    </td>
                    <td class="text-right" style="padding-right: 15px !important">
                      {{
                        getDetails(
                          $AppDetails.currency_details,
                          item.cus_currency,
                          "currency_symbol"
                        ) +
                          " " +
                          parseFloat(item.export_due_amount).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-tab>
          <b-tab
            class="px-0 py-0"
            v-if="
              list.retainer_invoice_details.length > 0 &&
                RoutePermission(false, '', 'invoice', 'paymentsreceived', 'index')
            "
            :title="'Customer Deposits(' + list.retainer_invoice_details.length + ')'"
          >
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th style="width: 140px; padding-left: 15px !important">
                      DATE
                    </th>
                    <th style="width: 100px">Customer Deposit</th>
                    <th style="width: 110px">STATUS</th>
                    <th class="text-right" style="min-width: 140px">AMOUNT</th>
                    <th class="text-right" style="min-width: 140px; padding-right: 15px !important">
                      BALANCE DUE
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in list.retainer_invoice_details" :key="index">
                    <td style="padding-left: 15px !important">
                      {{ getDateFormat(item.retainer_date) }}
                    </td>
                    <td v-if="RoutePermission(false, '', 'invoice', 'paymentsreceived', 'index')">
                      <router-link
                        class="event-link theme-text-color"
                        :to="{
                          name: 'RetainerInvoiceView',
                          params: { id: item.retainer_hdr_id },
                          query: {
                            page_from: 'quot_view',
                            id: $route.params.id,
                            quot_no: list.quotation_header_detail.quot_no,
                          },
                        }"
                        >{{ item.retainer_no }}</router-link
                      >
                    </td>
                    <td>{{ item.retainer_status_name }}</td>

                    <td class="text-right">
                      {{
                        getDetails(
                          $AppDetails.currency_details,
                          item.cus_currency,
                          "currency_symbol"
                        ) +
                          " " +
                          parseFloat(item.export_retainer_total).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                      }}
                    </td>
                    <td class="text-right" style="padding-right: 15px !important">
                      {{
                        getDetails(
                          $AppDetails.currency_details,
                          item.cus_currency,
                          "currency_symbol"
                        ) +
                          " " +
                          parseFloat(item.export_due_amount).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-tab>
        </b-tabs>
      </div>
      <!--  print template activation -->

      <FlyOver :show_full_layout="show_full_layout">
        <template slot="page-content" v-if="show_full_layout">
          <h5 class="mb-4 fw-semi-bold text-left">
            Quotation Templates
            <span class="float-right pr-2">
              <i
                class="la la-close cursor_pointer fw-semi-bold pr-1"
                @click="show_full_layout = false"
              ></i>
            </span>
          </h5>
          <QuotationPrint
            :show_full_layout="show_full_layout"
            :path="$route.fullPath"
          ></QuotationPrint>
        </template>
      </FlyOver>

      <b-modal
        id="converttoinvoice"
        size="sm"
        ref="modal"
        body-class="bg-white"
        cancel-title="Close"
        cancel-variant="light"
        :ok-title-html="convertsubmit == true ? loaderIcon + 'Yes' : 'Yes'"
        :title="'Convert to ' + convertmodule"
        @ok="converttoinvoice"
        :ok-disabled="convertsubmit"
      >
        <p>
          Are you sure you want to convert to
          {{ convertmodule }}
          ?
        </p>
      </b-modal>
      <!--  quotaion delete and status change modal -->
      <GlobalModal
        :content="content"
        :module="module"
        :title="title"
        :data="globalmodaldata"
        :isRoute="isRoute"
        :RoutePlace="RoutePlace"
        :type="globalmodaltype"
        :route_history="route_history"
        v-on:setSuccessHandlingModal="getSuccessHandlingModal"
      />
    </template>
  </div>
</template>

<script>
import getPageTitle from "@/utils/get-page-title"; // to set page title
import RecordNotFound from "@/pages/Error/RecordNotFound";
import QuotationPrint from "@/pages/Settings/Invoice/Quotationprint";
import { mapState, mapGetters } from "vuex";
import { notificationMixin } from "@/mixins/notification";
import { number_to_words } from "@/mixins/NumberToWords";
//  available print designs
import StandardPrint from "@/components/Form/Sales/Print/Standard";
import SpreadsheetPrint from "@/components/Form/Sales/Print/Spreadsheet";
import RetailPrint from "@/components/Form/Sales/Print/Retail";
import FlyOver from "@/components/Layout/Flyover";
import store from "@/store/index";
export default {
  mixins: [notificationMixin],
  name: "SalesView",
  components: {
    QuotationPrint,
    StandardPrint,
    SpreadsheetPrint,
    RetailPrint,
    RecordNotFound,
    FlyOver,
  },
  data() {
    return {
      isRoute: "",
      RoutePlace: "",
      bill_of_supply: "",
      inv_type: "",
      content: "",
      module: "",
      globalmodaltype: "",
      globalmodaldata: "",
      title: "",
      convertmodule: null,
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      show_full_layout: false,
      showprintlabel: false,
      convertsubmit: false,
      printlabel: "",
      show_notes: false,
      submit: false,

      approvesubmit: false,

      imageSrc: `data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5v
                    cmcvMjAwMC9zdmciIHdpZHRoPSIxOTEiIGhlaWdodD0iMTQxIj48cmVjdCB3aWR0aD0
                    iMTkxIiBoZWlnaHQ9IjE0MSIgZmlsbD0iI2VlZSIvPjx0ZXh0IHRleHQtYW5jaG9yPS
                    JtaWRkbGUiIHg9Ijk1LjUiIHk9IjcwLjUiIHN0eWxlPSJmaWxsOiNhYWE7Zm9udC13Z
                    WlnaHQ6Ym9sZDtmb250LXNpemU6MTJweDtmb250LWZhbWlseTpBcmlhbCxIZWx2ZXRp
                    Y2Esc2Fucy1zZXJpZjtkb21pbmFudC1iYXNlbGluZTpjZW50cmFsIj4xOTF4MTQxPC9
                    0ZXh0Pjwvc3ZnPg==`,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      total_in_words: "",
      route_history: "",
      field: {},
    };
  },
  methods: {
    converttoinvoice() {
      store
        .dispatch("invoice/quotationtoinvoice", parseInt(this.$route.params.id))
        .then((response) => {
          if (response.data.code != 200) {
            window.Messenger().post({
              extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
              message: response.data.status,
              type: response.data.type,
              showCloseButton: true,
            });
          } else {
            this.$router.push({
              name: "InvoiceCreate",
              query: {
                quotation: this.$route.params.id,
                type: this.convertmodule == "invoice" ? "invoice" : "bill_of_supply",
              },
            });
          }
        });
    },
    converttoretainer() {
      store
        .dispatch("retainer/fetchQuotDetails", parseInt(this.$route.params.id))
        .then((response) => {
          if (response.data.code != 200) {
            window.Messenger().post({
              extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
              message: response.data.status,
              type: response.data.type,
              showCloseButton: true,
            });
          } else {
            this.$router.push({
              name: "RetainerInvoiceCreate",
              query: {
                quot_id: this.$route.params.id,
              },
            });
          }
        });
    },
    async getviewdetails() {
      await store.dispatch("sales/fetchviewList", parseInt(this.$route.params.id));
    },

    getSuccessHandlingModal(ev) {
      if (
        this.globalmodaltype == "cancel" ||
        this.globalmodaltype == "approve" ||
        this.globalmodaltype == "draft" ||
        this.globalmodaltype == "accept"
      ) {
        this.list.quotation_header_detail.quot_status = ev.data.status_id;
        this.list.quotation_header_detail.quot_status_name = ev.data.status_name;
        store.dispatch("sales/fetchviewList", parseInt(this.$route.params.id));
      }
    },
    //Customize overlay for Print
    async showFullLayout() {
      await store
        .dispatch("settings/fetchinvoicesettings", {
          stg_menu: "Sales",
        })
        .then(() => {
          this.show_full_layout = true;
        });
    },

    handlingapprovingmodal(ev) {
      this.content = ev.content;
      this.module = ev.module;
      this.globalmodaldata = ev.data;
      this.title = ev.title;
      this.isRoute = ev.isRoute;
      this.RoutePlace = ev.RoutePlace;
      this.globalmodaltype = ev.type;
      this.route_history = ev.route_history || "";
      this.$root.$emit("bv::show::modal", "handlingapprovingmodal");
    },
    async emailstatement() {
      await this.getviewdetails();
      if (this.status_code != 404) {
        this.$router.push({
          name: "Email",
          query: {
            tns_type: "Quotation",
            tns_date: this.list.quotation_header_detail.quot_created_date,
            cus_id: this.list.quotation_header_detail.cus_id,
            cus_name: this.list.quotation_header_detail.cus_name,
            tns_no: this.list.quotation_header_detail.quot_no,
            tns_mail: this.list.quotation_header_detail.cus_mail,
            tns_currency: this.list.quotation_header_detail.cus_currency,
            id: this.$route.params.id,
            date_format: this.org_details.date_format,
          },
        });
      }
    },
    getTempProps() {
      this.field = this.$store.state.permission.print_settings_details["Sales"].template_list;
    },

    async handlePrint() {
      await this.getviewdetails();
      if (this.status_code != 404) {
        await this.getTempProps();
        document.title =
          this.list.quotation_header_detail.quot_no +
          " / " +
          this.list.quotation_header_detail.quot_created_date;
        var id;
        var style;
        var size;
        if (this.quot_settings_details.print.templateId == 4) {
          id =
            this.field.temp_prop.paper_size == 0
              ? this.field.temp_prop.orientation == 0
                ? "a4-standard-portrait-page"
                : "a4-standard-landscape-page"
              : this.field.temp_prop.paper_size == 1
              ? this.field.temp_prop.orientation == 0
                ? "a5-standard-portrait-page"
                : "a5-standard-landscape-page"
              : "";
          style = "standard";
          size =
            this.field.temp_prop.paper_size == 0
              ? this.field.temp_prop.orientation == 0
                ? "size:A4;"
                : "size:A4 landscape;"
              : this.field.temp_prop.paper_size == 1
              ? this.field.temp_prop.orientation == 0
                ? "size:A5;"
                : "size:A5 landscape;"
              : "";
        } else if (this.quot_settings_details.print.templateId == 5) {
          id =
            this.field.temp_prop.paper_size == 0
              ? this.field.temp_prop.orientation == 0
                ? "a4-spreadsheet-portrait-page"
                : "a4-spreadsheet-landscape-page"
              : this.field.temp_prop.paper_size == 1
              ? this.field.temp_prop.orientation == 0
                ? "a5-spreadsheet-portrait-page"
                : "a5-spreadsheet-landscape-page"
              : "";
          size =
            this.field.temp_prop.paper_size == 0
              ? this.field.temp_prop.orientation == 0
                ? "size:A4;"
                : "size:A4 landscape;"
              : this.field.temp_prop.paper_size == 1
              ? this.field.temp_prop.orientation == 0
                ? "size:A5;"
                : "size:A5 landscape;"
              : "";
          style = "spreadsheet";
        } else {
          id =
            this.field.temp_prop.paper_size == 0
              ? "inch3-thermal-print-page"
              : "inch4-thermal-print-page";
          style = "retail";
          size = "";
        }
        var win;
        const element = document.getElementById(id);
        var printcontent = "";
        for (
          var i = 1;
          i <= this.general_settings_details.preferences.default_print_preference;
          i++
        ) {
          this.showprintlabel = await true;
          this.printlabel = await this.general_settings_details.preferences.document_copy_label[i];
          printcontent +=
            (await ' <div style="page-break-after:always">') + element.innerHTML + "</div>";
        }

        win = window.open("", "Title", "fullscreen=yes", "titlebar=yes", "scrollbars=yes");
        win.document.write(`
            <html>
              <head>
                <title>${document.title}</title>
                 <style>
                @page{
               ${size}
                margin:0 !important;
                }
                </style>
                <link rel="stylesheet" href="${
                  process.env.VUE_APP_INVOICE_API_URL
                }/css/print/${style}.css">
               
              </head>
              <body class="${id}">
                ${printcontent}
              </body>
            </html>
          `);
        if (navigator.userAgent.indexOf("Safari") != -1) {
          setTimeout(() => {
            win.document.close();
            this.printlabel = "";
            this.showprintlabel = false;
            win.focus();
            win.print();
          }, 500);
          setTimeout(() => {
            win.close();
          }, 5000);
        } else {
          setTimeout(() => {
            win.document.close();
            this.printlabel = "";
            this.showprintlabel = false;
            win.focus();
            win.print();
            win.close();
          }, 500);
        }
      }
    },
    approvequotation() {
      this.approvesubmit = true;
      this.$store
        .dispatch(
          "sales/approvequotation",
          JSON.stringify({
            id: this.$route.params.id,
          })
        )
        .then(() => {
          this.approvesubmit = false;
          this.$refs.approvequotation.hide();
          //  code for notificatin display

          window.Messenger().post({
            extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
            message: "The Quotation has been approved successfully.",
            type: "success",
            showCloseButton: true,
          });
        });
    },
    // to convert the status from one to another
    changeStatus() {
      this.loading = false;
      this.convertsubmit = true;
      // required data for api
      var id = JSON.stringify({
        status_id: 3,
        quot_hdr_id: this.$route.params.id,
        inv_type: this.inv_type,
      });
      // call the changestatus api to convert the status from one to another
      store
        .dispatch("sales/changeStatus", {
          id: id,
          convertmodule: this.convertmodule,
        })
        .then(() => {
          this.convertsubmit = false;
          var routename = "SalesOrderView";
          var id = this.$route.params.id;
          if (this.convertmodule == "invoice") {
            routename = "InvoiceView";
            id = this.updated_id;
          }
          // once again refresh the list after status has been changed
          this.$router.push({
            name: routename,
            params: {
              id: id,
            },
          });
        });
    },
  },

  created() {
    this.getTempProps();
    // this.mail_id = this.list.quotation_header_detail.cus_mail;
    this.total_in_words =
      "Rupees " + number_to_words(this.list.quotation_header_detail.total_value);

    this.initializationMessengerCode();
    this.bill_of_supply = this.general_settings_details.preferences.bill_of_supply;
    this.inv_type = this.list.is_non_taxable == 1 && this.bill_of_supply ? "2" : "1";
    this.imageSrc =
      this.org_details.org_logo != null
        ? `data:image/jpeg;base64,` + this.org_details.org_logo
        : this.imageSrc;
    document.title = getPageTitle(
      this.list.quotation_header_detail.quot_no + " | " + this.$route.meta.title
    );
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air",
    };
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      list: (state) => state.sales.list,
      email: (state) => state.sales.email,
      code: (state) => state.sales.code,
      status_code: (state) => state.sales.status_code,
      status_message: (state) => state.sales.status_message,
      status_type: (state) => state.sales.status_type,
      updated_id: (state) => state.sales.updated_id,
      sales_index_history: (state) => state.sales.sales_index_history,
    }),
    ...mapGetters(["org_details", "general_settings_details", "quot_settings_details"]),
  },
};
</script>

<style></style>
